import apiClient from '@/utils/axios'

const searchLawyer = {
  async getSearchList(searchData) {
    const response = await apiClient.get('/search', {params: searchData})
    return response
},
  async getByCity(city) {
    const response = await apiClient.get('/city/' + city)
    return response
},
  async getBySpecialization(spec) {
    const response = await apiClient.get('/specialization/' + spec)
    return response
},
}

export {searchLawyer}
